import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';

export const StyledSpan = styled.span`
  font-size: inherit;
  font-weight: inherit;
  color: ${({ $color }) => ($color ? themeGet(`colors.${$color}`) : '#2B2C32')};
  text-decoration: ${({ $textUnderline }) =>
    $textUnderline ? 'underline' : 'normal'};
`;
